import * as yup from 'yup';

export const AddApiConfigSchema = yup.object().shape({
  userId: yup.string().required('User ID is required'),
  userApiKey: yup.string().required('User API key is required'),
  userPassword: yup.string().required('User Password is required'),
  campaignId: yup.string().required('Campaign ID is required'),
  accountId: yup.string().required('Account ID is required')
});
